<ng-container *ngIf="table && visible">
  <div [ngSwitch]="table.layout">
    <app-map-table *ngSwitchCase="'MAP'" [table]="table" [visibleRecords]="visibleRecords"
      [waiting]="waiting"></app-map-table>
    <app-pie-table *ngSwitchCase="'PIE'" [table]="table" [visibleRecords]="visibleRecords"
      [waiting]="waiting"></app-pie-table>
    <app-grid-table *ngSwitchDefault [table]="table" [visibleRecords]="visibleRecords" [waiting]="waiting">
    </app-grid-table>
  </div>
</ng-container>
